import Dialog from './Dialog';
import createConfirmation from './createConfirmation';

const confirm = createConfirmation(Dialog);

export default function (confirmation, options = {}) {
  return confirm({ confirmation, ...options });
}
